export enum ReduxLoggingLevel {
  VERBOSE, // timing and state updates
  INFO, // timing only
  NONE,
}

const initialRouteName = 'HomeStack';
const reduxLoggingLevel = ReduxLoggingLevel.INFO;

export default {
  initialRouteName,
  reduxLoggingLevel,
};
